"use strict";

define(['app'], function (app) {
  return app.Backbone.Model.extend({
    defaults: {
      modal: {}
    },
    initialize: function initialize() {
      if (!app.translations) {
        app.translations = this;
        app.events.commands.execute('translations:mounted');
      }
    }
  });
});